module.exports = __webpack_public_path__ + "f9e54eaa7a7a94cb80735f8abb7e9934.csv";


/*****************
 ** WEBPACK FOOTER
 ** ./client/pages/inventory-variance/samples/AdjustmentbyVarianceQty.csv
 ** module id = 1302
 ** module chunks = 0
 **/